import axios from "axios";

export async function addPupilsToCategory(categoryId, pupilIds) {
    try {
        const response = await axios.post("/pupil/add-to-category", {
            categoryId,
            pupilIds,
        });
        return response.data;
    } catch (e) {
        const text = e.response?.data?.message || "Ошибка добавления учеников в целевую группу";
        throw new Error(text);
    }
}
